export default "__VITE_ASSET__CtIQvvUj__"